import { FormattedMessage } from 'react-intl'

const Home = props => {
  return <>
    <h1><FormattedMessage id={'app.title'} /></h1>
  </>

}

export default Home